import { theme } from "@/styles/theme";
import styled from "@emotion/styled";
import { Checkbox, Flex, Table, Text } from "@mantine/core";
import {
  WorksItemGet200ResponseRowsInner,
  WorksSlittingScrapDetailPost200ResponseInner,
} from "@sizlcorp/sizl-api-document/dist/models";
import { useTranslation } from "react-i18next";
import { useWorkActions } from "../workByManagement/hooks/useWorkActions";
import { useWorkState } from "../workByManagement/hooks/useWorkState";

interface WorkOperationTableRowInRowProps {
  slittingData: Record<number, WorksSlittingScrapDetailPost200ResponseInner> | undefined;
  rowData: WorksItemGet200ResponseRowsInner;
  workIds?: number[] | Record<number, number>;
  onCheckedPart?: (checked: boolean) => void;
}
export const WorkSlittingTableInRowHead = (props: WorkOperationTableRowInRowProps) => {
  const { slittingData, rowData, workIds, onCheckedPart } = props;
  const { t } = useTranslation();
  const actions = useWorkActions();
  const state = useWorkState();

  const workIdsArray: number[] = Array.isArray(workIds)
    ? workIds
    : workIds
      ? Object.values(workIds)
      : [];

  const selectedIdSet = new Set<number>(
    Object.keys(state.scrapWorkIds || {})
      .map((k) => Number(k))
      .filter((n) => !Number.isNaN(n)),
  );
  const isRowFullySelected =
    workIdsArray.length > 0 && workIdsArray.every((id) => selectedIdSet.has(Number(id)));

  const firstSlitting = workIdsArray[0] ? slittingData?.[workIdsArray[0]] : undefined;

  return (
    <WorkRowTr>
      <td>
        <Table withBorder withColumnBorders>
          <thead>
            <WorkRowTr>
              <th>
                <Flex justify={"center"}>
                  <Checkbox
                    checked={isRowFullySelected}
                    onChange={(e) => {
                      if (e.target.checked) {
                        // Build a record for this row's IDs only
                        const record: Record<number, number> = workIdsArray.reduce(
                          (acc, id) => {
                            acc[id] = id;
                            return acc;
                          },
                          {} as Record<number, number>,
                        );
                        actions.setScrapWorkIds(record);
                      } else {
                        actions.setScrapWorkIds(undefined);
                      }
                    }}
                  />
                </Flex>
              </th>
              <th>
                <Flex justify={"space-around"} align={"center"}>
                  <Checkbox
                    disabled={Object.keys(slittingData || {}).length === 0}
                    onChange={(e) => {
                      if (e.target.checked) {
                        onCheckedPart?.(true);
                      } else {
                        onCheckedPart?.(false);
                      }
                    }}
                  />
                  <Text size="md">등분</Text>
                </Flex>
              </th>
              <th>{t("work.materialLotName")}</th>
              <WorkRowTd>{firstSlitting?.materialLotName}</WorkRowTd>
              <th>{t("item.width")}</th>
              <WorkRowTd>{firstSlitting?.materialWidth}</WorkRowTd>
              <th>{t("item.weight")}</th>
              <WorkRowTd>{firstSlitting?.materialWeight}</WorkRowTd>
            </WorkRowTr>
          </thead>
        </Table>
      </td>
    </WorkRowTr>
  );
};

const WorkRowTr = styled.tr`
  .mantine-1r8slib > thead > tr > th {
    background-color: ${theme.colors?.gray?.[0]};
    color: ${theme.colors?.gray?.[9]};
    font-weight: bold;
    text-align: center;
    padding: 0.5rem;
  }
`;

const WorkRowTd = styled.td`
  background-color: white;
  color: ${theme.colors?.gray?.[9]};
  font-weight: bold;
  text-align: center;
  padding: 0.5rem;
`;
